import React from "react";
import EditorImage from "../../images/editorModule2.svg";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorProgressHeader = () => {
  const { isOneTimeAsset } = useEditorMainPageContext();

  return (
    <div className="middle-pannel-header-editor">
      {/* {isOneTimeAsset ? ( */}
      <div className="otc-editor-progress">
        <div className="otc-editor-progress-node active">
          <span className="otc-editor-progress-label">Author Banner</span>
          <span className="otc-editor-progress-dot" />
        </div>
        <span className="otc-editor-progress-connector" />
        <div className="otc-editor-progress-node">
          <span className="otc-editor-progress-label">Generate RSD</span>
          <span className="otc-editor-progress-dot" />
        </div>
        <span className="otc-editor-progress-connector" />
        <div className="otc-editor-progress-node">
          <span className="otc-editor-progress-label">Publish</span>
          <span className="otc-editor-progress-dot" />
        </div>
      </div>
      {/* ) : (
        <img className="journeyBarImageEditor" src={EditorImage} alt="" />
      )} */}
    </div>
  );
};
